import React from 'react';
import './InputCheckbox.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import { classNames } from '../../functions/classNames';

const InputCheckbox = (props, context) => (
  <div className={classNames('InputCheckbox', props.error ? 'hasError' : '')} style={props.style}>
    <div className="inputLabel">
      <span>{getLabel(context.locale, props.label)}</span>
      {props.required ? <span className="required">*</span> : ''}
    </div>
    <input
      type="checkbox"
      name={props.name}
      checked={props.value}
      onChange={props.handleChange}
    />
  </div>
);

InputCheckbox.contextTypes = {
  locale: PropTypes.string,
};

export default InputCheckbox;



// WEBPACK FOOTER //
// ./src/main/components/input/InputCheckbox.js